import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1b1e2f14"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pa-2 text-left" }
const _hoisted_2 = { class: "text-subtitle-1 font-weight-bold mb-2" }
const _hoisted_3 = {
  key: 0,
  class: "d-flex flex-wrap align-center ga-1 mt-2"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-caption me-1" }, "¿Quién pasa?", -1))
const _hoisted_5 = {
  key: 0,
  class: "text-caption text-medium-emphasis mb-1"
}
const _hoisted_6 = {
  key: 1,
  class: "d-flex align-center ga-2"
}
const _hoisted_7 = { class: "font-weight-bold" }
const _hoisted_8 = {
  key: 2,
  class: "d-flex align-center ga-2"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-medium-emphasis" }, "vs", -1))

import { computed, ref } from "vue";
import { PartidaTorneoDTO } from "@/interfaces/Partidas";
import { CruceCuadro, CuadroCopa, LadoCuadro } from "@/utils/cuadroCopa";
import { partidaJugada } from "@/utils/clasificacionLiga";
import { mensajeDelBack } from "@/utils/mensajeDelBack";
import { elegirQuienPasaAsync } from "@/services/CopaService";
import CardPartidaGestion from "@/components/GestionTorneos/CardPartidaGestion.vue";
import ModalError from "@/components/Commons/ModalError.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CuadroCopa',
  props: {
    idTorneo: {},
    cuadro: {},
    editable: { type: Boolean },
    desempateOrganizador: { type: Boolean },
    cerrada: { type: Boolean }
  },
  emits: ["partidaActualizada", "actualizado"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

// Las rondas y, al final, el tercer puesto
const secciones = computed(() => {
  const ultima = props.cuadro.rondas.length;
  const rondas = props.cuadro.rondas.map(r => ({
    clave: `ronda-${r.numero}`,
    nombre: r.nombre,
    textoPasa: r.numero === ultima ? "Campeón:" : "Pasa",
    cruces: r.cruces,
  }));
  return props.cuadro.tercerPuesto
    ? [
        ...rondas,
        {
          clave: "tercero",
          nombre: "Tercer puesto",
          textoPasa: "Tercero:",
          cruces: [props.cuadro.tercerPuesto],
        },
      ]
    : rondas;
});

const filtro = ref("todas");
const seccionesVisibles = computed(() =>
  filtro.value === "todas"
    ? secciones.value
    : secciones.value.filter(s => s.clave === filtro.value)
);

const nombreLado = (lado: LadoCuadro) =>
  lado.nick ?? (lado.pendiente ? "Por decidir" : "—");

// Los dos huecos vacíos: no hay nada que enseñar
const esVacio = (cruce: CruceCuadro) =>
  !cruce.a.idUsuario && !cruce.b.idUsuario && !cruce.a.pendiente && !cruce.b.pendiente;

function ladoQuePasa(cruce: CruceCuadro): 1 | 2 | null {
  const p = cruce.partida;
  if (!p || p.idUsuarioPasa == null) return null;
  return p.idUsuarioPasa === p.idUsuario1 ? 1 : p.idUsuarioPasa === p.idUsuario2 ? 2 : null;
}

const empateValidado = (cruce: CruceCuadro) =>
  !!cruce.partida &&
  partidaJugada(cruce.partida) &&
  cruce.partida.resultadoUsuario1 != null &&
  cruce.partida.resultadoUsuario1 === cruce.partida.resultadoUsuario2;

const empateSinDecidir = (cruce: CruceCuadro) =>
  empateValidado(cruce) && ladoQuePasa(cruce) === null;

const puedeElegir = (cruce: CruceCuadro) =>
  props.editable && props.desempateOrganizador && !props.cerrada && empateValidado(cruce);

const LADOS = [1, 2] as const;
const isGuardando = ref(false);
const showError = ref(false);
const mensajeError = ref("");

async function elegir(cruce: CruceCuadro, lado: 1 | 2) {
  const p = cruce.partida;
  if (!p || ladoQuePasa(cruce) === lado) return;
  isGuardando.value = true;
  try {
    await elegirQuienPasaAsync(
      props.idTorneo,
      p.idPartidaTorneo,
      lado === 1 ? p.idUsuario1 : p.idUsuario2
    );
    emit("actualizado");
  } catch (error) {
    mensajeError.value = mensajeDelBack(error, "No se ha podido elegir quién pasa.");
    showError.value = true;
  } finally {
    isGuardando.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_chip_group = _resolveComponent("v-chip-group")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.cuadro.campeon.idUsuario)
        ? (_openBlock(), _createBlock(_component_v_alert, {
            key: 0,
            type: "success",
            variant: "tonal",
            icon: "mdi-trophy",
            class: "mb-3"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Campeón: "),
              _createElementVNode("strong", null, _toDisplayString(_ctx.cuadro.campeon.nick), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (secciones.value.length > 1)
        ? (_openBlock(), _createBlock(_component_v_chip_group, {
            key: 1,
            modelValue: filtro.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filtro).value = $event)),
            column: "",
            mandatory: "",
            "selected-class": "text-primary"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_chip, {
                value: "todas",
                size: "small",
                filter: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Todas")
                ]),
                _: 1
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(secciones.value, (seccion) => {
                return (_openBlock(), _createBlock(_component_v_chip, {
                  key: seccion.clave,
                  value: seccion.clave,
                  size: "small",
                  filter: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(seccion.nombre), 1)
                  ]),
                  _: 2
                }, 1032, ["value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(seccionesVisibles.value, (seccion) => {
        return (_openBlock(), _createElementBlock("div", {
          key: seccion.clave,
          class: "mb-4"
        }, [
          _createElementVNode("h3", _hoisted_2, _toDisplayString(seccion.nombre), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(seccion.cruces, (cruce) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: cruce.numero
            }, [
              (cruce.partida)
                ? (_openBlock(), _createBlock(CardPartidaGestion, {
                    key: 0,
                    partida: cruce.partida,
                    editable: _ctx.editable,
                    etiqueta: seccion.cruces.length > 1 ? `Cruce ${cruce.numero}` : undefined,
                    pasa: ladoQuePasa(cruce),
                    onPartidaActualizada: _cache[1] || (_cache[1] = ($event: any) => (emit('partidaActualizada', $event)))
                  }, {
                    chips: _withCtx(() => [
                      (cruce.pasa.idUsuario)
                        ? (_openBlock(), _createBlock(_component_v_chip, {
                            key: 0,
                            size: "x-small",
                            color: "success"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(seccion.textoPasa) + " " + _toDisplayString(cruce.pasa.nick), 1)
                            ]),
                            _: 2
                          }, 1024))
                        : (empateSinDecidir(cruce))
                          ? (_openBlock(), _createBlock(_component_v_chip, {
                              key: 1,
                              size: "x-small",
                              color: "warning"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Empate: elige quién pasa ")
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                    ]),
                    default: _withCtx(() => [
                      (puedeElegir(cruce))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                            _hoisted_4,
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(LADOS, (lado) => {
                              return _createVNode(_component_v_btn, {
                                key: lado,
                                size: "small",
                                variant: ladoQuePasa(cruce) === lado ? 'flat' : 'outlined',
                                color: "success",
                                onClick: ($event: any) => (elegir(cruce, lado))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(lado === 1 ? cruce.partida.nick1 : cruce.partida.nick2), 1)
                                ]),
                                _: 2
                              }, 1032, ["variant", "onClick"])
                            }), 64))
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1032, ["partida", "editable", "etiqueta", "pasa"]))
                : (!esVacio(cruce))
                  ? (_openBlock(), _createBlock(_component_v_card, {
                      key: 1,
                      variant: "outlined",
                      class: "mb-2 hueco"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card_text, { class: "pa-3" }, {
                          default: _withCtx(() => [
                            (seccion.cruces.length > 1)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_5, " Cruce " + _toDisplayString(cruce.numero), 1))
                              : _createCommentVNode("", true),
                            (cruce.pasa.idUsuario)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                  _createElementVNode("span", _hoisted_7, _toDisplayString(cruce.pasa.nick), 1),
                                  _createVNode(_component_v_chip, {
                                    size: "x-small",
                                    color: "success"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Pasa sin jugar")
                                    ]),
                                    _: 1
                                  })
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                  _createElementVNode("span", {
                                    class: _normalizeClass(["lado", { 'text-medium-emphasis': !cruce.a.nick }])
                                  }, _toDisplayString(nombreLado(cruce.a)), 3),
                                  _hoisted_9,
                                  _createElementVNode("span", {
                                    class: _normalizeClass(["lado text-right", { 'text-medium-emphasis': !cruce.b.nick }])
                                  }, _toDisplayString(nombreLado(cruce.b)), 3)
                                ]))
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true)
            ], 64))
          }), 128))
        ]))
      }), 128))
    ]),
    _createVNode(_component_v_dialog, {
      modelValue: isGuardando.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((isGuardando).value = $event)),
      persistent: "",
      width: "200"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "pa-6 d-flex justify-center" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_progress_circular, {
              indeterminate: "",
              color: "primary",
              size: "60"
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (showError.value)
      ? (_openBlock(), _createBlock(ModalError, {
          key: 0,
          isVisible: showError.value,
          message: mensajeError.value,
          "onUpdate:isVisible": _cache[3] || (_cache[3] = ($event: any) => (showError.value = $event))
        }, null, 8, ["isVisible", "message"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})